import {
  ArrayMaxSize,
  ArrayUnique,
  IsArray,
  IsBoolean,
  IsIn,
  IsInt,
  IsNotEmpty,
  IsOptional,
  IsString,
  Max,
  MaxLength,
  Min,
} from 'class-validator';
import {
  DOCUMENT_TYPE_DOMAINS,
  DOCUMENT_TYPE_RECURRENCE_ANCHORS,
  type DocumentTypeDomain,
  type DocumentTypeRecurrenceAnchor,
  MAX_CATALOG_WARNING_DAYS,
} from './document-type-catalog.constants';
import { IsAllowedLegalRefUrl } from './is-allowed-legal-ref-url.decorator';

export class CreateDocumentTypeDto {
  @IsString()
  @IsNotEmpty()
  @MaxLength(100)
  name!: string;

  @IsString()
  @IsOptional()
  description?: string;

  @IsString()
  @IsOptional()
  icon?: string;

  @IsBoolean()
  @IsOptional()
  required?: boolean;

  @IsOptional()
  @IsIn(DOCUMENT_TYPE_DOMAINS)
  domain?: DocumentTypeDomain | null;

  @IsOptional()
  @IsInt()
  @Min(1)
  @Max(240)
  defaultValidityMonths?: number | null;

  @IsOptional()
  @IsArray()
  @ArrayMaxSize(MAX_CATALOG_WARNING_DAYS)
  @ArrayUnique()
  @IsInt({ each: true })
  @Min(1, { each: true })
  @Max(365, { each: true })
  defaultWarningDays?: number[];

  @IsOptional()
  @IsIn(DOCUMENT_TYPE_RECURRENCE_ANCHORS)
  recurrenceAnchor?: DocumentTypeRecurrenceAnchor | null;

  @IsBoolean()
  @IsOptional()
  warningOnly?: boolean;

  @IsBoolean()
  @IsOptional()
  isPersonal?: boolean;

  @IsOptional()
  @IsAllowedLegalRefUrl()
  @MaxLength(500)
  legalRefUrl?: string | null;

  @IsInt()
  @Min(0)
  @Max(100000)
  @IsOptional()
  sortOrder?: number;
}
